var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51816 9.14131L12.0166 11.6391L11.1912 12.4646L8.69333 9.96614C7.76393 10.7112 6.60791 11.1164 5.41675 11.1147C2.51875 11.1147 0.166748 8.76272 0.166748 5.86472C0.166748 2.96672 2.51875 0.614723 5.41675 0.614723C8.31475 0.614723 10.6667 2.96672 10.6667 5.86472C10.6684 7.05589 10.2632 8.2119 9.51816 9.14131ZM8.348 8.70847C9.08831 7.94716 9.50175 6.92664 9.50008 5.86472C9.50008 3.60839 7.6725 1.78139 5.41675 1.78139C3.16041 1.78139 1.33341 3.60839 1.33341 5.86472C1.33341 8.12047 3.16041 9.94806 5.41675 9.94806C6.47866 9.94973 7.49918 9.53629 8.2605 8.79597L8.348 8.70847Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.e6a3bf257fe828f9f5a05429ac5105f4.svg";
export { ForwardRef as ReactComponent };